import { Component, ElementRef, Input, OnInit, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { AnalyticsService } from '../analytics.service';
import { TimeSheetService } from 'src/app/services/time-sheet.service';
import { CdkDragMove } from '@angular/cdk/drag-drop';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { months } from '../../_models/staticArray';
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
import { FilterService } from 'src/app/services/filter.service';
import { UtilityService } from 'src/app/services/utility.service';
import { JobHoursModelComponent } from 'src/app/time-sheet/learner-single-week/job-hours-model/job-hours-model.component';
import { ClientService } from 'src/app/services/client.service';
import { UserTimeSheetService } from 'src/app/services/user-time-sheet.service';
const moment = extendMoment(Moment);

@Component({
  selector: 'live-fatigue-score',
  templateUrl: './live-fatigue-score.component.html',
  styleUrls: ['./live-fatigue-score.component.scss']
})
export class LiveFatigueScoreComponent implements OnInit {
  @Input('selectedTab') selectedTab
  datesRanges = []
  userTimelogs: any
  dataSource: MatTableDataSource<any>;
  pageSize = 25;
  pageSizeOptions: number[] = [25, 50, 100];
  sort: MatSort;
  paginator: MatPaginator;
  @ViewChildren('resizableColumn') resizableColumns: QueryList<ElementRef>;
  columnWidths: { [key: string]: number } = {};
  displayedColumns: string[] = ['name']
  startDate
  endDate
  yearList = []
  selectedYear
  currentYear
  today
  months = months
  weeknumber;
  nextWeek: number;
  previousWeek: number;
  allWeeks: any[];
  tempWeekNumber: any;
  selectedWeek
  loading = false
  filterActive = false
  noDataMsg = {
    title: "No Users!",
    data: "No matching users found."
  }
  searchText
  clientList = []


  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  constructor(
    public _analyticsService: AnalyticsService,
    public _timeSheetService: TimeSheetService,
    public _filterService: FilterService,
    public _utilityService: UtilityService,
    public _clientService: ClientService,
    public _userTimeSheetService: UserTimeSheetService
  ) {
    this.dataSource = new MatTableDataSource<any>([]);
  }

  async ngOnInit() {
    this.loading = true
    this.getCurrentWeekDates()
    this.getClientList()
    this.getWeeknumberwithDates()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedTab && changes.selectedTab.currentValue === 0) {
      console.log("THIS IS THE SELECTED TAB INDEX", changes.selectedTab.currentValue)
      this.getCurrentWeekDates()
    }
  }


  // UTILITY

  updateData(data) {
    // this.paginator.pageIndex = this.pageIndex
    this.dataSource = new MatTableDataSource(data);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  previous() {
    let index = this.allWeeks.findIndex((x) => x._id == this.selectedWeek)
    console.log("THISIS THE INDEX OF WEEK", index)
    this.selectedWeek = this.allWeeks[index - 1]._id
    this.startDate = this.allWeeks[index - 1].startDate
    this.endDate = this.allWeeks[index - 1].endDate
    this.datesRanges = this.allWeeks[index - 1].dateList
    console.log("THIS IS THE DATE RANGES", this.datesRanges)
    console.log("START AND END DATE", this.startDate, this.endDate)
    this.loading = true
    this.getLiveFatigueScore('test3')

  }

  next() {
    let index = this.allWeeks.findIndex((x) => x._id == this.selectedWeek)
    console.log("THISIS THE INDEX OF WEEK", index)
    this.selectedWeek = this.allWeeks[index + 1]._id
    this.startDate = this.allWeeks[index + 1].startDate
    this.endDate = this.allWeeks[index + 1].endDate
    this.datesRanges = this.allWeeks[index + 1].dateList
    console.log("THIS IS THE DATE RANGES", this.datesRanges)
    console.log("START AND END DATE", this.startDate, this.endDate)
    this.loading = true
    this.getLiveFatigueScore('test2')
  }


  getCurrentWeekDates() {
    this.getWeekDates().then((dateList) => {
      this.getLiveFatigueScore('test1')
    })
  }


  getWeekDates() {
    return new Promise((resolve, reject) => {
      let obj = {
        _isWeek: true
      }
      this._timeSheetService.getRailWeekDates(obj).subscribe((data) => {
        console.log("DATA OF CURRENT WEEK", data)
        this.datesRanges = data[0].dateList
        this.selectedWeek = data[0]._id
        this.startDate = data[0].startDate
        this.endDate = data[0].endDate
        resolve(this.datesRanges)
      }, error => {
        console.log("ERROR WHILE GET RAIL WEEK DATES", error)
      })
    })
  }




  filter(searchText) {
    console.log("WHAT IS THE SEARCH TEXT", searchText)
    this.filterActive = true;
    let jobData = this.userTimelogs
    if (!searchText) {
      this.filterActive = false;
      this.updateData(jobData);
      return;
    }
    let tempDataSource = this._filterService.filter1(searchText, jobData, ['name']);
    this.updateData(tempDataSource)
    if (tempDataSource.length <= 0) {
    } else this.filterActive = false
  }


  singleDayLog(data) {
    console.log("SINGLE DAY LOG", data)
    data.log['extraDetails'] = data.log.details && data.log.details.extraDetails ? data.log.details.extraDetails : ''
    data.log['livingAllowance'] = data.log.details && data.log.details.livingAllowance ? data.log.details.livingAllowance : false
    data.log['payRate'] = data.log.details && data.log.details.payRate ? data.log.details.payRate : ''
    data.log['paidHours'] = data.log.details && data.log.details.paidHours ? data.log.details.paidHours : false
    data.log['expense'] = data.log.details && data.log.details.expense ? data.log.details.expense : false
    data.log['deduction'] = data.log.details && data.log.details.deduction ? data.log.details.deduction : false
    data.log['date'] = moment(data.log.date).format("DD/MM/YYYY")
    let obj = {
      data: { value: data.log },
      learner: data.userId,
      previousDayLog: data && data.previousDateData ? data.previousDateData : null,
      clientList: this.clientList,
      isInstructor: true,
      type: 'adminSheet'
    }

    console.log("SINGLE DAY OBJECT", obj)

    this._utilityService.commonDialogBoxOpen(JobHoursModelComponent, obj).afterClosed().subscribe((added) => {
      if (added == undefined) {
        data.log['date'] = this._userTimeSheetService.covertDateFormate(data.log.date, 'MM/DD/YYYY')
        return;
      }
      else {
        console.log("LOGS ADDED DONE", added)
        this._utilityService.openSnackBar("Performing calculations for fatigue and risk assessment. Please wait... The latest score is being calculated.", "Ok")
        this.getLiveFatigueScore('test4')
      }
    })

  }

  currentPage(event) {
    console.log("PAGE EVENT", event)
  }

  // API CALL

  getLiveFatigueScore(type) {
    console.log("CALLING THIS FUNCTION", type)
    this._analyticsService.getLiveFatigueScore(this.datesRanges).subscribe((res) => {
      this.userTimelogs = res
      this.displayedColumns = ['name', ...this.datesRanges]
      this.updateData(this.userTimelogs)
      this._utilityService.openSnackBar("The fatigue and risk index score has been updated.", "Ok")
      this.loading = false
    }, error => {
      console.log("ERROR", error)
      this.loading = false
    })
  }


  getWeeknumberwithDates() {
    this._timeSheetService.getRailWeekDates({}).subscribe((data) => {
      console.log("THIS IS THE LIST OF WEEK DATES", data, this.selectedWeek)
      this.allWeeks = data
    }, error => {
      console.log("ERROR WHILE GET WEEK DATES", error)
    })
  }

  getClientList() {
    this._clientService.getClients().subscribe((res) => {
      console.log("THIS IS THE CLIENT LIST TO BE DISPLAY", res)
      this.clientList = res.map((x) => {
        let obj = {
          name: x.name,
          _id: x._id,
          // projectCodes: x.projectCodes
        }
        return obj
      })
      console.log("THIS IS THE FINAL CLIENT LIST", this.clientList)
    }, error => {
      console.log("ERROR WHILE GET CLIENTS", error)
    })
  }

}
